import { render, staticRenderFns } from "./NewXline.vue?vue&type=template&id=1f566e2c&scoped=true"
import script from "./NewXline.vue?vue&type=script&lang=js"
export * from "./NewXline.vue?vue&type=script&lang=js"
import style0 from "./NewXline.vue?vue&type=style&index=0&id=1f566e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f566e2c",
  null
  
)

export default component.exports